import { Injector, inject, provideAppInitializer } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { LanguageService } from './services/language/language.service';
import { SharedService } from './services/shared/shared.service';
import { UserService } from './services/user/user.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

async function initialize(injector: Injector) {
  const platform = injector.get(Platform);
  const translate = injector.get(TranslateService);
  const languageService = injector.get(LanguageService);
  const storage = injector.get(Storage);
  const router = injector.get(Router);
  const sShared = injector.get(SharedService);
  const sUser = injector.get(UserService);

  await storage.create();
  // StatusBar.setBackgroundColor({ color: '#0072aa' });

  translate.setDefaultLang('pt');
  await firstValueFrom(translate.use(translate.getBrowserLang() ?? 'pt'));
  await storage.get('language').then(async iso => {
    if (iso) {
      await firstValueFrom(translate.use(iso));
    } else {
      await firstValueFrom(translate.use(translate.getBrowserLang() ?? 'pt'));
      storage.set('language', translate.getBrowserLang());
    }
  });

  await platform.ready();
  // isLogged(router, sShared, sUser);
}

export const Initialize = provideAppInitializer(() => {
  const initializerFn = ((injector: Injector) => () => {
    return initialize(injector);
  })(inject(Injector));
  return initializerFn();
});
